import type { FinanceProvider } from '@kanda-libs/ks-frontend-services';

export const MODAL_ID = 'company-custom-rates-modal';

export const ALL_RATE_ID = 'all';

// Lenders that require a per-company external user id (stored as the `xid` on
// the company's lender_configs). When one of these is selected in the modal, an
// extra field is shown to capture that id. Extend this list as needed.
export const PROVIDERS_REQUIRING_USER_ID: FinanceProvider[] = [
  'propensio',
  'humm',
  'humm_re',
];
